export default __webpack_public_path__ + "static/media/masks.b2679579.png";